import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, PageHeader, Row, Col, Button } from 'antd'
import Filters, { FilterItem, Types } from '../../components/Filters'
import SpecieList from '../../components/SpecieList'
import { SpecieForm } from '../../components/Forms'
import { SpecieProvider, SpecieConsumer } from '../../context/SpecieContext'

export default class Specie extends Component {

  private specieFilterDispatchOptions = {
    options: {
      sort: []
    }
  } as const

  specieListSearch = {
    search: {
      deleted: false
    }
  }

  handleFiltersSubmit = (payload: any) => {
    if (payload && payload.search) {
      this.specieListSearch.search = payload.search
    }
  }

  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to="specie/add">
        <Button type="primary" shape="round">
          Create new species
        </Button>
      </Link>
    )
  }

  render() {
    const { permissions, history, goBack, match: { params: { specieUuid } } }: any = this.props

    return (
      <SpecieProvider>
        <SpecieConsumer>
          {({ fetching, error, species, specie, pagination, requestSpecieList, requestSpecieFind, requestSpecieCreate, requestSpecieUpdate, requestSpecieDelete }) => {

            // Edit user
            if (specieUuid) {
              let addon: any = {
                data: specie,
                permissions: permissions
              }
              if (specieUuid !== 'add') {
                addon = {
                  ...addon,
                  uuid: specieUuid
                }
              }

              return (
                <Card>
                  <PageHeader title={specieUuid === 'add' ? 'New Species' : 'Edit Species'} onBack={() => goBack('/admin/specie')}>
                    <SpecieForm
                      {...addon}

                      loading={fetching}
                      error={error}
                      history={history}

                      loadSpecie={requestSpecieFind}
                      dispatchCreate={requestSpecieCreate}
                      dispatchUpdate={requestSpecieUpdate}
                    />
                  </PageHeader>
                </Card>
              )
            }

            return (
              <>
                <Card title="Filters" style={{marginBottom: 25}}>
                  <Filters size="medium" loading={fetching} history={history} defaultSubmitOptions={this.specieFilterDispatchOptions} submitDispatch={requestSpecieList} onSubmit={this.handleFiltersSubmit}>
                    {({ values, handleFilterChange }: any) => (
                      <Row gutter={9} style={{width: '100%'}}>
                        <Col xs={24} md={12}>
                          <FilterItem
                            name="uuid"
                            type={Types.INPUT}
                            placeholder="Filter by UUID"
                            value={values['uuid']}
                            size="medium"
                            options={{
                              input: {
                                allowClear: true
                              }
                            }}
                            onChange={handleFilterChange}
                          />
                        </Col>

                        <Col xs={24} md={12}>
                          <FilterItem
                            name="name.ilike"
                            type={Types.INPUT}
                            placeholder="Filter by Name"
                            value={values['name.ilike']}
                            size="medium"
                            options={{
                              input: {
                                allowClear: true
                              }
                            }}
                            onChange={handleFilterChange}
                          />
                        </Col>
                      </Row>
                    )}
                  </Filters>
                </Card>

                <Card title="List of Species" extra={this.renderAdd()}>
                  <SpecieList
                    loading={fetching}
                    species={species}
                    pagination={pagination}
                    permissions={permissions}
                    history={history}
                    searchOptions={this.specieListSearch}
                    loadSpecies={requestSpecieList}
                    deleteSpecie={requestSpecieDelete}
                  />
                </Card>
              </>
            )
          }}
        </SpecieConsumer>
      </SpecieProvider>
    )
  }
}
